import {Route, Routes} from "react-router-dom";

import ArticlesListPage from "./pages/ArticlesListPage";
import ArticleEditPage from "./pages/ArticleEditPage";
import NotFound from "./pages/NotFound";

// TODO Take out crm module out of pages folder :)
const CRMRouter = () => {
    return (
        <Routes>
            <Route path="/articles" element={<ArticlesListPage />} />
            <Route path="/article/new" element={<ArticleEditPage />} />
            <Route path="/article/edit/:id" element={<ArticleEditPage />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default CRMRouter;